import type { FunctionComponent } from 'react';

import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { PaymentMethods } from '../../components/payment-methods/payment-methods';
import { RegistrationFlow } from '../../components/registration-flow/registration-flow';
// import { TermsLinks } from '../../components/terms-links/terms-links';

import styles from './registration.module.scss';

const style = createStyleHelper(styles, 'registration');

export interface IRegistrationProps {
    className?: string;
}

export const Registration: FunctionComponent<IRegistrationProps> = ({ className }) => {
    return (
        <div className={createClassName([className, style()])}>
            <div className={style('form')}>
                <RegistrationFlow />
                {/*<TermsLinks className={style('actions')}></TermsLinks>*/}
            </div>
            <div className={style('payment-methods')}>
                <PaymentMethods />
            </div>
        </div>
    );
};
